import type { IndustryCaseRecommendationData } from './const';

export function parseIndustryCaseRecommendation(value: unknown): IndustryCaseRecommendationData | null {
  try {
    let parsed = typeof value === 'string' ? JSON.parse(value) : value;
    if (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }
    const template = [parsed.template, parsed.case].find(
      item => item && ['id', 'name', 'thumbnailUrl', 'previewUrl'].every(key => typeof item[key] === 'string' && item[key]),
    );
    if (!template) {
      return null;
    }
    if (typeof parsed.recommendationId !== 'string' || !parsed.recommendationId) {
      return null;
    }
    if (typeof parsed.copy !== 'string' || !parsed.copy.trim()) {
      return null;
    }
    return {
      ...parsed,
      template,
      matchType: ['direct_tag', 'synonym', 'semantic'].includes(parsed.matchType) ? parsed.matchType : 'semantic',
    } as IndustryCaseRecommendationData;
  } catch {
    return null;
  }
}

export function parseEmbeddedIndustryCaseRecommendation(output: unknown): IndustryCaseRecommendationData | null {
  try {
    let parsed = typeof output === 'string' ? JSON.parse(output) : output;
    if (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }
    const recommendation = parseIndustryCaseRecommendation(parsed.industryCaseRecommendation);
    if (!recommendation) {
      return null;
    }
    return {
      ...recommendation,
      ...(typeof parsed.recommendationLatencyMs === 'number'
        ? { recommendationLatencyMs: parsed.recommendationLatencyMs }
        : {}),
      ...(typeof parsed.recommendationCandidateCount === 'number'
        ? { recommendationCandidateCount: parsed.recommendationCandidateCount }
        : {}),
      ...(typeof parsed.recommendationStatus === 'string'
        ? { recommendationStatus: parsed.recommendationStatus }
        : {}),
    };
  } catch {
    return null;
  }
}
